import { useEffect } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { useSearchParams } from "react-router-dom";
import LoadingScreen from "../../components/loading-screen/LoadingScreen";

const LogoutInitPage = () => {
  const { logout } = useAuth0();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    // Auth0 requires returnTo to exactly match an "Allowed Logout URL".
    // Do NOT include query params here (e.g. ?returnTo=...), because that often isn't whitelisted.
    const returnTo = searchParams.get("returnTo") || `${window.location.origin}/logout`;
    logout({
      logoutParams: {
        returnTo,
      },
    });
  }, [logout, searchParams]);

  return <LoadingScreen />;
};

export default LogoutInitPage;
